import cx from 'classnames'
import {
  Text,
  TextFontSizes,
  TextFontWeights,
  TextLineHeights,
} from '@cinch-labs/design-system'
import styles from './finance-lenders.module.css'
import { LenderPartnersText } from '../../types/locales'
import { Wrapper } from '@cinch-nx/shared-ui'

export type Endpoints = {
  staticAssetBaseUrl: string
}

interface FinanceLendersProps {
  i18n: LenderPartnersText
  className?: string
  children?: React.ReactNode
}

function FinanceLenders({ i18n, className }: FinanceLendersProps) {
  const STATIC_ASSET_DOMAIN = i18n.endpoints.staticAssetBaseUrl

  const lenders: {
    name: string
    webpSrc: string
    fallbackSrc: string
  }[] = [
    {
      name: 'Black Horse',
      webpSrc: `${STATIC_ASSET_DOMAIN}/finance/bh-logo.webp`,
      fallbackSrc: `${STATIC_ASSET_DOMAIN}/finance/bh-logo.png`,
    },
    {
      name: 'Evolution Funding',
      webpSrc: `${STATIC_ASSET_DOMAIN}/finance/evo-logo.webp`,
      fallbackSrc: `${STATIC_ASSET_DOMAIN}/finance/evo-logo.png`,
    },
    {
      name: 'Moto Novo Finance',
      webpSrc: `${STATIC_ASSET_DOMAIN}/finance/moto-novo.webp`,
      fallbackSrc: `${STATIC_ASSET_DOMAIN}/finance/moto-novo.png`,
    },
    {
      name: 'Santander Consumer Finance',
      webpSrc: `${STATIC_ASSET_DOMAIN}/finance/santander-cf-logo.webp`,
      fallbackSrc: `${STATIC_ASSET_DOMAIN}/finance/santander-cf-logo.png`,
    },
  ]
  return (
    <article className={cx(styles.lendingPartners, className)}>
      <Wrapper>
        <Text
          element="h2"
          fontSize={TextFontSizes['4xl']}
          fontWeight={TextFontWeights.bold}
          lineHeight={TextLineHeights.display}
          className={styles.lendingPartnersMainTitle}
        >
          {i18n.title}
        </Text>
        <Text fontSize={TextFontSizes.s} fontWeight={TextFontWeights.book}>
          {i18n.text}
        </Text>
        <div className={styles.lenderImagesContainer}>
          <ul className={styles.lenderImages}>
            {lenders.map((lender) => (
              <li key={lender.name} className={styles.lenderImageItem}>
                <picture className={styles.lenderImageContainer}>
                  <source srcSet={lender.webpSrc} type="image/webp" />
                  <img
                    src={lender.fallbackSrc}
                    alt={lender.name}
                    loading="lazy"
                    className={styles.lenderImage}
                  />
                </picture>
              </li>
            ))}
          </ul>
        </div>
      </Wrapper>
    </article>
  )
}

export default FinanceLenders
